























import Vue from 'vue';
import Component from 'vue-class-component';
import firebase from 'firebase';
import store from '@/store/store';
import { User, Likers } from '@/types';
import { getModule } from 'vuex-module-decorators';
import Auth from '@/store/modules/auth';
import Dialog from '@/store/modules/dialog';
import { Prop, Watch } from 'vue-property-decorator';

const authModule = getModule(Auth, store);
const dialogModule = getModule(Dialog, store);

@Component({})
export default class LikersDialog extends Vue {
  @Prop(Boolean)
  value!: boolean;
  usersToShow: User[] = [];

  get show() {
    return dialogModule.likersDialog;
  }
  set show(value) {
    const payload = { open: value };
    dialogModule.openLikersDialog(payload);
  }

  get likerUids() {
    return dialogModule.likerUids;
  }

  @Watch('show')
  async init() {
    this.usersToShow = [];
    for (let uid of this.likerUids) {
      let user = await this.$db.getUserData(uid);
      this.usersToShow.push(user);
    }
  }
}
